<template>
  <div class="content" style="background-color: #fff;height: auto;">
    <div class="app-body">
      <div class="head">
        <p><img src="../../assets/images/3.png"><span style="color: #FF4A09;font-size: .32rem;" v-text="formatArtificialCallLabel(customerInfo.newCallLabel)"></span></p>
        <p><span class="t_title">联系方式：</span><strong class="t_content"><a :href="'tel:'+customerInfo.number">
              <font color="#3B89FF" v-text="customerInfo.number"></font>
            </a></strong></p>
        <p><span class="t_title">姓名：</span><strong class="t_content" v-text="customerInfo.childName"></strong></p>
        <p><span class="t_title">年龄：</span><strong class="t_content" v-text="customerInfo.childAge"></strong></p>
        <p><span class="t_title">备注：</span><span class="t_content" v-text="customerInfo.remark"></span></p>
        <div class="oper">
          <a href="javascript:void(0)" @click="show=true;">
            <font v-if="customerInfo.finishStatus==3">待跟进</font>
            <font v-if="customerInfo.finishStatus==4">确认到店</font>
            <font v-if="customerInfo.finishStatus==5">邀约失败</font>
            <font v-if="customerInfo.finishStatus==6">未到店</font>
            <font v-if="customerInfo.finishStatus==7">到店未试听</font>
            <font v-if="customerInfo.finishStatus==8">试听成功</font>
            <font v-if="customerInfo.finishStatus==9">成交</font>
            <font v-if="customerInfo.finishStatus==10">未成交</font>
          </a><br>
          <span v-if="customerInfo.updateTime">上次跟进时间</span><br>
          <span v-text="customerInfo.updateTime" v-if="customerInfo.updateTime"></span>
        </div>
      </div>
      <div class="contont">
        <div>
          <font color="#666666">通话录音</font>
        </div>
        <div v-for="item in audioObj.talkList">
          <div class="ai" v-if="item.user=='ai'">
            <img src="../../assets/images/7.png">
            <div class="aidesc" v-text="item.word"></div>
          </div>
          <div class="user" v-if="item.user=='customer'">
            <div style="width: 5.23rem;">
              <div class="audio"><audio :src="item.file" controls="controls" v-if="item.file"></audio></div>
              <div class="userdesc" v-text="item.word"></div>
            </div>
            <img src="../../assets/images/8.png">
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="tag_group">
        <div style="width: 33.33%;">
          <font>邀约环节</font>
          <span @click="recordObj.finishStatus=4;" :class="recordObj.finishStatus==4?'active':''">确认到店</span>
          <span @click="recordObj.finishStatus=5;" :class="recordObj.finishStatus==5?'active':''">邀约失败</span>
        </div>
        <div style="width: 33.33%;">
          <font>到店环节</font>
          <span @click="recordObj.finishStatus=8;" :class="recordObj.finishStatus==8?'active':''">试听成功</span>
          <span @click="recordObj.finishStatus=6;" :class="recordObj.finishStatus==6?'active':''">未到店</span>
          <span @click="recordObj.finishStatus=7;" :class="recordObj.finishStatus==7?'active':''">到店未试听</span>
        </div>
        <div style="width: 33.33%;">
          <font>成交环节</font>
          <span @click="recordObj.finishStatus=9;" :class="recordObj.finishStatus==9?'active':''">成交</span>
          <span @click="recordObj.finishStatus=10;" :class="recordObj.finishStatus==10?'active':''">未成交</span>
        </div>
      </div>
      <div class="tag_group">
        <textarea placeholder="备注" v-model="recordObj.remark"></textarea>
      </div>
      <div class="tag_group">
        <a href="javascript:void(0)" @click="sumbit()">完成</a>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getClueDetail, getTalkTextByRecordId, updateFollowStatusAndRemarkByRecordId } from '../../api';
export default {
  name: 'template',
  data() {
    return {
      audioObj: {},
      recordId: "",
      customerInfo: {},
      show: false,
      recordObj: {
        recordId: "",
        finishStatus: "",
        remark: ""
      }
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]); return "";
    },
    formatArtificialCallLabel(operationClass) {
      if (operationClass == "A") {
        return "A (精准意向)"
      }
      if (operationClass == "B") {
        return "B (一般意向)"
      }
      if (operationClass == "C") {
        return "C (未接号码)"
      }
      if (operationClass == "D") {
        return "D (无意向)"
      }
      if (operationClass == "E") {
        return "E (年龄不符)"
      }
      if (operationClass == "F") {
        return "F (位置不符)"
      }
      if (operationClass == "G") {
        return "G (潜在投诉)"
      }
      if (operationClass == "H") {
        return "H (无效号码)"
      }
    },
    getClueDetail() {
      var that = this;
      getClueDetail("?recordId=" + that.recordId).then(function (res) {
        // res = res.data;
        if (res.code == 1) {
          that.customerInfo = res.data;
          that.recordObj.finishStatus = that.customerInfo.finishStatus;
          that.recordObj.remark = that.customerInfo.remark;
        } else {
          that.$toast(res.message)
        }
      })
    },
    getTalkTextByRecordId() {
      var that = this;
      getTalkTextByRecordId("?recordId=" + that.recordId).then(function (res) {
        // res = res.data;
        if (res.code == 1) {
          that.audioObj = res.data;
        } else {
          that.$toast(res.message)
        }
      })
    },
    sumbit() {
      var that = this;
      that.recordObj.recordId = that.recordId;
      updateFollowStatusAndRemarkByRecordId(that.recordObj).then(function (res) {
        // res = res.data;
        if (res.code == 1) {
          that.show = false;
          that.getClueDetail();
          that.$toast('操作成功!');
        } else {
          that.$toast(res.message)
        }
      })
    }
  },
  mounted() {
    this.recordId = this.getQueryString("id");
    this.getTalkTextByRecordId();
    this.getClueDetail();
  }
}
</script>
<style type="text/css">
html,
body,
#app,
.app-body {
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 0.24rem;
  background-color: #fff;
}
.app-body {
  background-image: url(../../assets/images/10.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  position: absolute;
  top: 0;
  left: 0;
}
.head {
  width: 7.14rem;
  height: 3.54rem;
  background-image: url(../../assets/images/9.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0.22rem auto;
  box-sizing: border-box;
  padding-top: 0.2rem;
  position: relative;
}
.head p {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 0.4rem;
  line-height: 0.3rem;
  margin: 0.2rem 0;
  color: #2b3a59;
  font-size: 0.28rem;
}
.head .t_title {
  max-width: 1.4rem;
}
.head .t_content {
  width: 5rem;
  max-height: 0.6rem;
  overflow: hidden;
}
.head p img {
  height: 0.3rem;
  margin-right: 0.15rem;
}
.head .oper {
  position: absolute;
  top: 0.4rem;
  right: 0.3rem;
  text-align: center;
  width: 2.2rem;
}
.head .oper a {
  display: inline-block;
  /*width:1.6rem;*/
  padding: 0 0.25rem;
  height: 0.56rem;
  background: rgba(59, 137, 255, 1);
  border-radius: 28px;
  font-size: 0.3rem;
  line-height: 0.56rem;
  color: #fff;
  margin-bottom: 0.1rem;
}
.head .oper span {
  font-size: 0.2rem;
  color: #777777;
  /*line-height: .1rem;*/
}
.contont {
  width: 7rem;
  margin: 0.22rem auto;
}
.ai {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0.3rem 0;
}
.user {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin: 0.3rem 0;
}
.ai img,
.user img {
  width: 0.72rem;
}
.ai .aidesc {
  max-width: 5.23rem;
  box-sizing: border-box;
  padding: 0.2rem 0.3rem;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  margin-left: 0.2rem;
}
.user .userdesc {
  max-width: 5.23rem;
  width: auto;
  box-sizing: border-box;
  padding: 0.2rem 0.3rem;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  margin-right: 0.2rem;
  float: right;
}
.audio {
  max-width: 5.23rem;
  box-sizing: border-box;
  padding: 0 0.2rem;
  text-align: right;
  margin-bottom: 0.1rem;
}
.audio audio {
  width: 100%;
}
.tag_group {
  display: flex;
  justify-content: center;
  margin-top: 0.3rem;
}
.tag_group span {
  width: 2.08rem;
  height: 0.78rem;
  line-height: 0.78rem;
  background-color: #f9f9fb;
  border-radius: 0.08rem;
  border: 0.02rem solid #f9f9fb;
  font-size: 0.3rem;
  color: #222222;
  text-align: center;
  margin: 0.15rem auto;
  display: block;
}
.tag_group font {
  width: 2.08rem;
  height: 0.78rem;
  line-height: 0.78rem;
  font-size: 0.3rem;
  color: rgba(59, 137, 255, 1);
  text-align: center;
  margin: 0.15rem auto;
  display: block;
}
.tag_group span.active {
  border: 0.02rem solid rgba(59, 137, 255, 1);
  box-shadow: 0px 0px 24px 0px rgba(10, 65, 148, 0.17);
  color: #3b89ff;
  background-color: rgba(234, 244, 254, 1);
}
.tag_group textarea {
  width: 6.86rem;
  height: 1.34rem;
  box-sizing: border-box;
  padding: 0.3rem;
  font-size: 0.3rem;
  border: 0.02rem solid #eeeeee;
}
.tag_group a {
  width: 6.86rem;
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  background: rgba(59, 137, 255, 1);
  border: 1px solid rgba(43, 118, 231, 1);
  border-radius: 0.44rem;
  color: #fff;
  font-size: 0.32rem;
}
</style>


// WEBPACK FOOTER //
// src/views/clue/index.vue